// src/screens/AuthPage.jsx

import React, { useState } from "react";

import { useAuth } from "../context/AuthContext";


const API_URL = import.meta.env.VITE_API_URL || "https://eleven11-i6v4.onrender.com";

export default function AuthPage() {
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const { refreshUser } = useAuth();


  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });

  const updateForm = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    try {
      const endpoint =
        mode === "login"
          ? "/auth/login"
          : "/auth/register";

      const body =
        mode === "login"
          ? {
              email: form.email,
              password: form.password,
            }
: { ...form, phone: form.phone.replace(/\D/g, "") };

    const res = await fetch(`${API_URL}${endpoint}`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify(body),
});

const data = await res.json();

if (!res.ok) {
  throw new Error(data.message || "Something went wrong");
}

localStorage.setItem("token", data.token);
localStorage.setItem("user", JSON.stringify(data.user));

await refreshUser();



window.location.href =
  data.user?.role === "admin"
    ? "/admin"
    : "/";


    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

const placeholderStyles = `
  input::placeholder {
    color: #8e8e93;
    font-weight: 500;
  }
`;


  return (
    <>

<style>{placeholderStyles}</style>

      <div style={styles.page}>




        <div style={styles.card}>


          {/* BRAND */}
          <div style={styles.brand}>
            <h1 style={styles.logo}>ELEVEN</h1>
            <p style={styles.subtitle}>
             OEM marine distribution, reimagined.
            </p>
          </div>

          {/* TABS */}
          <div style={styles.tabs}>
            <button
              onClick={() => setMode("login")}
              style={{
                ...styles.tabButton,
                ...(mode === "login"
                  ? styles.activeTab
                  : {}),
              }}
            >
              Login
            </button>

            <button
              onClick={() => setMode("register")}
              style={{
                ...styles.tabButton,
                ...(mode === "register"
                  ? styles.activeTab
                  : {}),
              }}
            >
              Create Account
            </button>
          </div>

          {/* FORM */}
          <form
            onSubmit={handleSubmit}
            style={styles.form}
          >
            {mode === "register" && (
              <div style={styles.nameRow}>
                <input
                  type="text"
                  placeholder="First Name"
                  value={form.firstName}
                  onChange={(e) =>
                    updateForm(
                      "firstName",
                      e.target.value
                    )
                  }
                  style={styles.input}
                  required
                />

                <input
                  type="text"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={(e) =>
                    updateForm(
                      "lastName",
                      e.target.value
                    )
                  }
                  style={styles.input}
                  required
                />
              </div>
            )}


{mode === "register" && (
         <input
  type="tel"
  placeholder="(786) 444-9340"
  value={form.phone}
  onChange={(e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    let display = digits;
    if (digits.length >= 6) display = `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
    else if (digits.length >= 3) display = `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    else if (digits.length > 0) display = `(${digits}`;
    updateForm("phone", display);
  }}
  style={styles.input}
  required
/>
            )}


            <input
              type="email"
              placeholder="Email Address"
              value={form.email}
              onChange={(e) =>
                updateForm("email", e.target.value)
              }
              style={styles.input}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={form.password}
              onChange={(e) =>
                updateForm(
                  "password",
                  e.target.value
                )
              }
              style={styles.input}
              required
              minLength={8}
            />

            {error && (
              <p style={styles.error}>
                {error}
              </p>
            )}

      <button
  type="submit"
  style={styles.submitButton}
  disabled={loading}

  onMouseEnter={(e) => {
    e.currentTarget.style.transform =
      "translateY(-3px) scale(1.01)";

    e.currentTarget.style.boxShadow =
      "0 26px 50px rgba(0,0,0,0.18)";
  }}

  onMouseLeave={(e) => {
    e.currentTarget.style.transform =
      "translateY(0px) scale(1)";

    e.currentTarget.style.boxShadow =
      "0 12px 30px rgba(0,0,0,0.10)";
  }}

  onMouseDown={(e) => {
    e.currentTarget.style.transform =
      "translateY(-1px) scale(0.99)";
  }}

  onMouseUp={(e) => {
    e.currentTarget.style.transform =
      "translateY(-3px) scale(1.01)";
  }}
>
  {loading
    ? "Please wait..."
    : mode === "login"
    ? "Login"
    : "Create Account"}
</button>
          </form>

          {/* FOOTER */}
          <div style={styles.footer}>
            <span style={styles.footerText}>
              {mode === "login"
                ? "New to 1111?"
                : "Already have an account?"}
            </span>

            <button
              onClick={() =>
                setMode(
                  mode === "login"
                    ? "register"
                    : "login"
                )
              }
              style={styles.footerButton}
            >
              {mode === "login"
                ? "Create Account"
                : "Login"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
page: {
  minHeight: "100vh",
  background: "#f5f5f7",
  display: "flex",
  alignItems: window.innerWidth <= 768 ? "flex-start" : "center",
  justifyContent: "center",
  padding: window.innerWidth <= 768 ? "20px 16px 24px" : "24px",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
},

card: {
  width: "100%",
  maxWidth: 560,
  position: "relative",
  background: "rgba(255,255,255,0.58)",
  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)",
  borderRadius: 36,
  border: "1px solid rgba(255,255,255,0.65)",
  padding: window.innerWidth <= 768 ? "48px 32px 52px" : "58px 46px",
  boxShadow: `
    inset 0 1px 0 rgba(255,255,255,0.92),
    0 10px 30px rgba(0,0,0,0.04),
    0 40px 80px rgba(0,0,0,0.04)
  `,
},


  brand: {
    textAlign: "center",
    marginBottom: 40,
  },

logo: {
  color: "#0A0A0A",
  fontSize: window.innerWidth <= 768 ? 48 : 64,
  fontWeight: 700,
  letterSpacing: "-3px",
  lineHeight: 0.94,
  margin: 0,
},


  subtitle: {
    color: "#6e6e73",
    marginTop: 14,
    fontSize: 21,
    fontWeight: 500,
    letterSpacing: -0.3,
    lineHeight: 1.4,
  },

  tabs: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    background: "#f2f2f4",
    borderRadius: 18,
    padding: 5,
    marginBottom: 30,
  },

  tabButton: {
    height: 52,
    border: "none",
    background: "transparent",
    color: "#6e6e73",
    borderRadius: 14,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 15,
    transition:
      "all 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
  },

  activeTab: {
    background: "#ffffff",
    color: "#000",
    boxShadow:
      "0 2px 10px rgba(0,0,0,0.06)",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },

  nameRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
  },

  input: {
    height: 60,
    borderRadius: 18,
    border: "1px solid transparent",
    background: "#f2f2f4",
    color: "#000",
    padding: "0 20px",
    fontSize: 16,
    fontWeight: 500,
    outline: "none",
    transition:
      "all 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
    boxSizing: "border-box",
  },

  error: {
    color: "#d93025",
    fontSize: 14,
    margin: 0,
    paddingLeft: 4,
    fontWeight: 500,
  },

submitButton: {
  height: 64,

  borderRadius: 999,

  border: "none",

  background: "#111111",

  color: "#ffffff",

  fontSize: 15,
  fontWeight: 700,
  letterSpacing: "0.2px",

  cursor: "pointer",

  marginTop: 8,

  transition:
    "all .25s ease",

  boxShadow:
    "0 12px 30px rgba(0,0,0,0.10)",
},
  footer: {
    marginTop: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    flexWrap: "wrap",
  },

  footerText: {
    color: "#86868b",
    fontSize: 15,
    fontWeight: 500,
  },

  footerButton: {
    background: "none",
    border: "none",
    color: "#000",
    fontWeight: 700,
    cursor: "pointer",
    fontSize: 15,
    padding: 0,
  },
};